import { PREMIUM_FORECAST_DAYS, NON_PREMIUM_FORECAST_DAYS } from 'common/constants';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

type ForecastDaysType = 'home' | 'spot' | 'favorites' | 'forecast-content';

export const forecastDaysAllowed = ({
  type,
  isEntitled,
  customDays,
  query,
}: {
  type: ForecastDaysType;
  isEntitled: boolean | undefined;
  customDays?: number;
  query?: Record<string, string | string[] | undefined>;
}) => {
  const isNative = query?.native?.toString() === 'true';
  const nativeForecastDays = query?.forecastDays ? Number(query.forecastDays) : null;

  if (isEntitled) {
    return PREMIUM_FORECAST_DAYS;
  }

  if (
    isNative &&
    nativeForecastDays &&
    nativeForecastDays >= 5 &&
    nativeForecastDays <= 10 &&
    type === 'forecast-content'
  ) {
    return nativeForecastDays;
  }

  if (customDays && customDays > 0) {
    return customDays;
  }

  return NON_PREMIUM_FORECAST_DAYS;
};

export const useForecastDaysAllowed = ({
  type,
  isEntitled,
  customDays,
}: {
  type: ForecastDaysType;
  isEntitled: boolean | undefined;
  customDays?: number;
}) => {
  const router = useRouter();
  const { query } = router;
  const days = useMemo(
    () =>
      forecastDaysAllowed({
        type,
        isEntitled,
        customDays,
        query,
      }),
    [customDays, isEntitled, query, type],
  );

  return {
    forecastDaysAllowed: days,
  };
};

export default forecastDaysAllowed;
